import {
    Campaign,
    CategoryTab,
    GlobalRetailEvent,
    Showstopper,
    UpcomingCampaign,
} from '@shared/types/mylounge';
import { CampaignFilterTags } from '@client/components/mylounge/banner/constants';
import { CategoryTabIds } from '@shared/constants';

export interface State {
    openCampaigns: Campaign[];
    tabs: CategoryTab[];
    showstoppers: Showstopper[];
    upcomingCampaigns: UpcomingCampaign[];
    globalRetailEvents: GlobalRetailEvent[];
    loading: boolean;
    error?: string;
    imagesLoaded: boolean;
    categoryTabId: CategoryTabIds;
    filterTag: CampaignFilterTags;
}

export const initialState: State = {
    openCampaigns: [],
    tabs: [],
    showstoppers: [],
    upcomingCampaigns: [],
    globalRetailEvents: [],
    loading: false,
    error: undefined,
    imagesLoaded: false,
    categoryTabId: CategoryTabIds.ALL,
    filterTag: CampaignFilterTags.ALL,
};
